import React, { useState, useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { FirstSection, Features3, ProductPicture, HowMade, BrandStory, Samurai, Footer } from "./parts";

export const Top = () => {
  const ref = useRef();
  const [width, setWidth] = useState(ref.current?.clientWidth);

  useLayoutEffect(() => {
    setWidth(ref.current?.clientWidth);
  }, [ref]);

  return (
    <div>
      <FirstSection />

      <Features3 />

      <StyledDivProducts ref={ref}>
        <ProductPicture
          title="Gem Box - 5pcs Crystal Treats"
          url="https://misaky.tokyo/products/gem-box"
          pictureName={width > 700 ? "five-pcs-box__square" : "five-pcs-box"}
        />

        <ProductPicture
          title="Jewelry Box - 8pcs Crystal Treats"
          url="https://misaky.tokyo/products/jewerly-box"
          pictureName={width > 700 ? "eight-pcs-box__square" : "eight-pcs-box"}
        />
      </StyledDivProducts>

      {/* <ProductPicture
        title="Jewelry Box - 5pcs"
        url="https://misaky.tokyo/products/rainbow-pride-box-limited-edition"
        pictureName="gift-set"
      /> */}

      {/* <FeaturesWithBox /> */}

      {/* <CustomerVoices /> */}

      <HowMade />

      <BrandStory />

      <Samurai />

      <Footer />
    </div>
  );
};

const StyledDivProducts = styled.div`
  display: flex;
  flex-direction: column;
  ${media.greaterThan("medium")`
    flex-direction: row;
  `};
`;
